<template>
  <page>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <message :messages="messages"></message>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-card-title>
            </v-card-title>
            <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :loading="loading"
            :server-items-length="totalItems"
            :no-data-text="noDataText"
            v-bind:options.sync="pagination"
            >
            <template v-slot:item="row">
              <tr>
                <td class="text-right">{{ row.item.id }}</td>
                <td class="text-right">{{ row.item.tranId }}</td>
                <td class="text-right">{{ row.item.dataFileType }}</td>
                <td class="text-right">{{ formatDate(row.item.tranDate) }}</td>
                <td class="text-right">{{ row.item.tranTime }}</td>
                <td class="text-right">{{ row.item.polNo }}</td>
                <td class="text-right">{{ row.item.vehRegNo }}</td>
                <td class="text-right">{{ row.item.chassNo }}</td>
                <td class="text-right">{{ formatDate(row.item.comDate) }}</td>
                <td class="text-right">{{ formatDate(row.item.expDate) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row"  :inprogress="true" :error="true" @inprogress="doInprogress" @error="doError"></table-action>
                </td>
              </tr>
            </template>
          </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <confirm v-model="promptConfirm" @ok="doAction">
      <p>Are you sure you want to send the selected record?</p>
      <div class="queryValue">Transaction ID: {{ selectedItem.tranId }}</div>
      <div class="queryValue">Insurance Transaction Type: {{ selectedItem.actionDesc }}</div>
    </confirm>
  </page>
</template>

<script>
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      headers: [
        { text: 'Id', align: 'left', value: 'id' },
        { text: 'Transacation Id', align: 'right', value: 'tranId' },
        { text: 'Data File Type', align: 'right', value: 'dataFileType' },
        // { text: 'Insured Company', align: 'right', value: 'insCo' },
        { text: 'Transaction Date', align: 'right', value: 'tranDate' },
        { text: 'Transaction Time', align: 'right', value: 'tranTime' },
        { text: 'Policy No', align: 'right', value: 'polNo' },
        { text: 'Vechile Reg No.', align: 'right', value: 'vecRegNo' },
        { text: 'Chassis Number', align: 'right', value: 'chassNo' },
        { text: 'Com Date', align: 'right', value: 'comDate' },
        { text: 'Exp Date', align: 'right', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        dataFileType: 'INS_DAT_FILE_3'
      },
      filtersLabel: {
      },
      tabs: null,
      isClearFilter: true,
      pagination: {
        sortDesc: [false],
        page: 1
      },
      promptConfirm: false,
      selectedItem: {
        id: undefined,
        tranId: undefined,
        action: undefined,
        actionDesc: undefined
      }
    }
  },
  computed: {
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData()
    }
  },
  methods: {
    async fetchData() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.recLtaDataFile3List
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((data) => {
                const item = {
                  id: data.id,
                  tranId: data.tranId,
                  dataFileType: data.dataFileType,
                  tranDate: data.tranDate,
                  tranTime: data.tranTime,
                  polNo: data.polNo,
                  vehRegNo: data.vehRegNo,
                  chassNo: data.chassNo,
                  comDate: data.comDate,
                  expDate: data.expDate
                }
                this.items.push(item)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doAction() {
      this.promptConfirm = false
      const apiURI = this.$store.state.underwriting.dataTransferSettings.menu.sendToLtaAction
      if (apiURI) {
        this.loading = true
        try {
          let sendForm = {
            id: this.selectedItem.id,
            action: this.selectedItem.action
          }
          await this.$http.post(apiURI, sendForm)
          this.$toast.success('Submitted Successfully.')
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doInprogress(data) {
      if (data && data.item && data.item.id) {
        this.selectedItem = {
          id: data.item.id,
          tranId: data.item.tranId,
          action: 'I',
          actionDesc: 'In-progress'
        }
        this.promptConfirm = true
      }
    },
    doError(data) {
      console.log(data.item)
      if (data && data.item && data.item.id) {
        this.selectedItem = {
          id: data.item.id,
          tranId: data.item.tranId,
          action: 'E',
          actionDesc: 'Error'
        }
        this.promptConfirm = true
      }
    },
    doClearFilters() {
    },
    doFilters() {
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        // this.fetchData()
      })
    } else {
      // this.fetchData()
    }
  },
  mounted() {
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  components: {
  }
}
</script>

<style lang="scss">
</style>
